import * as React from 'react';

export function SvgJira() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
          fill="#1868DB"
        />
        <path
          d="M9.05131 15.4336H7.73368C5.74643 15.4336 4.3208 14.2164 4.3208 12.4341H11.4058C11.773 12.4341 12.0106 12.6949 12.0106 13.0644V20.1938C10.2393 20.1938 9.05131 18.7593 9.05131 16.7595V15.4336ZM12.5506 11.8907H11.233C9.24571 11.8907 7.82008 10.6952 7.82008 8.91284H14.905C15.2722 8.91284 15.5315 9.15194 15.5315 9.52145V16.6509C13.7602 16.6509 12.5506 15.2163 12.5506 13.2166V11.8907ZM16.0715 8.36944H14.7538C12.7666 8.36944 11.341 7.15223 11.341 5.36987H18.4259C18.7931 5.36987 19.0307 5.63071 19.0307 5.97848V13.1079C17.2595 13.1079 16.0715 11.6733 16.0715 9.6736V8.36944Z"
          fill="white"
        />
      </svg>
    </span>
  );
}
